
import * as React from "react"
import {
  Select as ShadcnSelect,
  SelectTrigger as ShadcnSelectTrigger,
  SelectContent as ShadcnSelectContent,
  SelectItem as ShadcnSelectItem,
  SelectValue as ShadcnSelectValue
} from "@/components/ui/select"
import { cn } from "@/lib/utils"

export interface EnhancedSelectProps extends React.ComponentPropsWithoutRef<typeof ShadcnSelect> {
  children?: React.ReactNode;
  defaultValue?: string;
  value?: string;
  onValueChange?: (value: string) => void;
}

export const EnhancedSelect = ({ children, ...props }: EnhancedSelectProps) => {
  return (
    <ShadcnSelect {...props}>
      {children}
    </ShadcnSelect>
  );
};
EnhancedSelect.displayName = "EnhancedSelect";

export interface EnhancedSelectTriggerProps extends React.ComponentPropsWithoutRef<typeof ShadcnSelectTrigger> {
  children?: React.ReactNode;
  className?: string;
}

export const EnhancedSelectTrigger = React.forwardRef<HTMLButtonElement, EnhancedSelectTriggerProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <ShadcnSelectTrigger 
        ref={ref} 
        className={cn(className)} 
        {...props}
      >
        {children}
      </ShadcnSelectTrigger>
    );
  }
);
EnhancedSelectTrigger.displayName = "EnhancedSelectTrigger";

export interface EnhancedSelectContentProps extends React.ComponentPropsWithoutRef<typeof ShadcnSelectContent> {
  children?: React.ReactNode;
  className?: string;
}

export const EnhancedSelectContent = React.forwardRef<HTMLDivElement, EnhancedSelectContentProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <ShadcnSelectContent 
        ref={ref} 
        className={cn(className)} 
        {...props}
      >
        {children}
      </ShadcnSelectContent>
    );
  }
);
EnhancedSelectContent.displayName = "EnhancedSelectContent";

export interface EnhancedSelectItemProps extends React.ComponentPropsWithoutRef<typeof ShadcnSelectItem> {
  children?: React.ReactNode;
  className?: string;
  value: string;
}

export const EnhancedSelectItem = React.forwardRef<HTMLDivElement, EnhancedSelectItemProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <ShadcnSelectItem 
        ref={ref} 
        className={cn(className)} 
        {...props}
      >
        {children}
      </ShadcnSelectItem>
    );
  }
);
EnhancedSelectItem.displayName = "EnhancedSelectItem";

export interface EnhancedSelectValueProps extends React.ComponentProps<typeof ShadcnSelectValue> {
  children?: React.ReactNode;
  placeholder?: string;
}

export const EnhancedSelectValue = ({ children, ...props }: EnhancedSelectValueProps) => {
  return (
    <ShadcnSelectValue {...props}>
      {children}
    </ShadcnSelectValue>
  );
};
EnhancedSelectValue.displayName = "EnhancedSelectValue";

// Export the enhanced components as the default names
export const Select = EnhancedSelect;
export const SelectTrigger = EnhancedSelectTrigger;
export const SelectContent = EnhancedSelectContent;
export const SelectItem = EnhancedSelectItem;
export const SelectValue = EnhancedSelectValue;
